<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title>
            Abmeldung
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <template v-if="loading">
            <v-container>
              <v-row align="center" justify="center">
                <v-col>
                  <v-progress-circular />
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col>
                  Sie werden abgemeldet...
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-else>
            <v-alert v-if="success" type="success">
              Sie wurden abgemeldet.
            </v-alert>
            <v-alert v-else type="error">
              Abmeldung fehlgeschlagen.
            </v-alert>
            <v-btn
              color="primary"
              block
              :to="{name: 'login'}"
            >
              Zur Anmeldung
            </v-btn>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      success: false,
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  async mounted () {
    this.loading = true
    try {
      if (await this.logout()) {
        this.success = true
      }
    } finally {
      this.loading = false
    }
    this.$store.dispatch('logout')
  },
  methods: {
    ...mapActions(['logout']),
  },
}
</script>
